import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Pagination,
  CircularProgress
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useTranslation } from "react-i18next";
import CustomText, { textStyles } from "../../../../components/CustomText";
import ExportDropdown from "../../../../components/ExportDropdown";
import tablefilter from "../../../../assets/tablefilter.svg";
import StatusDropdown from "../../../../components/StatusDropdown";
import AddTask from "./AddTask";
import SearchInput from "../../../../components/SearchInput";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import TruncatedCell from "../../../../components/TruncatedCell.js";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import EditTask from "./EditDrawer.js";
import logoutmodel from "../../../../assets/logoutmodel.svg";
import DeleteTaskModal
  from "./DeleteModal.js";
import FilterDrawer from "./FilterDrawer.js";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import empty from "../../../../assets/empty.png";
import ExportTasksExcel from "./TaskExcel.js";
import ExportTasksPDF from "./TaskPdf.js";
import { pdf } from "@react-pdf/renderer";
import { toast } from "react-hot-toast";
import { useCompanyProfile } from "../../../../components/CompanyProfile";
import { useMemo } from "react";
import CustomButton from "../../../../components/CustomButton";
import {
  convertLocalDateTimeToUTC,
  convertUTCToLocalDateTime,
} from "../../../../components/dateTimeUtils";

// ✅ Status colors remain same
const statusColors = {
  Assigned: "#8F00FF",
  Ongoing: "#8E65E9",
  Completed: "#00C48C",
  Delayed: "#FF974A",
  Paused: "#FFDC60",
};

// const TasksTable = ({ onSelectTask, onMapFilter,statusFilter,  onClearStatus,priorityFilter
//  }) => {
const TasksTable = ({
  onSelectTask,
  onMapFilter,
  statusFilter,
  onClearStatus,
  priorityFilter,
  taskViewTab,
  setTaskViewTab,
}) => {
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const authToken = decryptedToken?.trim() || null;
  useEffect(() => {
    if (priorityFilter) {
      setFilters(prev => ({
        ...prev,
        priority: priorityFilter
      }));
      setPage(1);
    }
  }, [priorityFilter]);
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const [openAddTask, setOpenAddTask] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [tasks, setTasks] = useState([]);
  const [deleteTaskId, setDeleteTaskId] = useState(null);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [filters, setFilters] = useState({
    priority: "",
    startDate: "",
    endDate: "",
  });
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [openEditTask, setOpenEditTask] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [reviewAnchorEl, setReviewAnchorEl] = useState(null);
  const [reviewMenuRow, setReviewMenuRow] = useState(null);
  const [reviewTargetTask, setReviewTargetTask] = useState(null);
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false);
  const [reviewAction, setReviewAction] = useState(null); // "approve" | "reject"
  const [reviewNotes, setReviewNotes] = useState("");
  const [reviewSubmitting, setReviewSubmitting] = useState(false);
  const [reviewLoadingTaskId, setReviewLoadingTaskId] = useState(null);
  // const filteredTasks = useMemo(() => {
  //   if (!statusFilter) return tasks;
  //   return tasks.filter(task => task.status === statusFilter);
  //   if (priorityFilter) {
  //   result = result.filter(t => t.priority === priorityFilter);
  // }
  // }, [tasks, statusFilter,priorityFilter]);

  const filteredTasks = useMemo(() => {
    let result = tasks;

    if (statusFilter) {
      result = result.filter(t => t.status === statusFilter);
    }

    // if (priorityFilter) {
    //   result = result.filter(t => t.priority === priorityFilter);
    // }

    return result;
  }, [tasks, statusFilter,]);


  const isAnyFilterApplied = useMemo(() => {
    return (
      !!statusFilter ||
      !!filters.status ||
      !!filters.priority ||
      !!filters.startDate ||
      !!filters.endDate
    );
  }, [statusFilter, filters, priorityFilter]);

  const fetchTasks = async (page = 1, sort = sortOrder, filters = {}, q = "") => {
    try {
      setLoading(true);

      let url = `${BASE_URL}/task-management/admin/tasks?page=${page}&page_size=5&sort=created_at:${sort}`;


      if (q) url += `&q=${encodeURIComponent(q)}`;
      // ✅ append filters
      if (filters.startDate) {
        url += `&from=${encodeURIComponent(filters.startDate)}`;
      }
      if (filters.endDate) {
        url += `&to=${encodeURIComponent(filters.endDate)}`;
      }
      if (filters.priority) url += `&priority=${filters.priority}`;
      if (filters.status) url += `&status=${filters.status}`;

      console.log("📡 Fetching:", url);

      const res = await fetch(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const data = await res.json();

      console.log("✅ API Response:", data);

      if (!data.error) {
        setTasks(data.data.tasks || []);
        setTotalPages(data.data.pagination.pages);
        setPage(data.data.pagination.page);
      }
    } catch (err) {
      console.error("❌ Error fetching tasks:", err);
    } finally {
      setLoading(false);
      setIsInitialLoad(false);
    }
  };

  const getTodayDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const effectiveFilters = useMemo(() => {
    if (taskViewTab === "today") {
      const today = getTodayDate();
      // Local calendar day → UTC range (matches table display timezone)
      return {
        ...filters,
        startDate: convertLocalDateTimeToUTC(`${today}T00:00:00`) || "",
        endDate: convertLocalDateTimeToUTC(`${today}T23:59:59`) || "",
      };
    }
    return filters;
  }, [taskViewTab, filters]);

  useEffect(() => {
    fetchTasks(page, sortOrder, effectiveFilters); // ✅ refetch when filters/tab changes
  }, [page, sortOrder, effectiveFilters]);
  useEffect(() => {
    const delay = setTimeout(() => {
      fetchTasks(1, sortOrder, effectiveFilters, searchTerm);
    }, 400); // debounce


    return () => clearTimeout(delay);
  }, [searchTerm, sortOrder, effectiveFilters]);

  const toggleSort = () => {
    setSortOrder((prev) => {
      const newOrder = prev === "desc" ? "asc" : "desc";
      console.log("🔄 Sort order changed:", newOrder); // ✅ log sort order
      return newOrder;
    });
  };
  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap

    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
    whiteSpace: 'nowrap', // ✅ Prevent text wrap

    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  // 🔹 Helper function for date formatting
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    const formattedDateTime = convertUTCToLocalDateTime(dateString, {
      locale: "en-GB",
      formatOptions: {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      },
    });

    return formattedDateTime === "—" ? "-" : formattedDateTime;
  };


  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  // const handleMenuOpen = (event, row) => {
  //   setAnchorEl(event.currentTarget);
  //   setSelectedRow(row);
  // };
  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    // setSelectedRow(null);
  };

  const handleView = async () => {
    if (selectedRow) {
      onSelectTask(selectedRow.id); // ✅ pass only the task id
    }
    handleMenuClose();
  };
  const handleOpenReviewMenu = (event, row) => {
    event.stopPropagation();
    setReviewAnchorEl(event.currentTarget);
    setReviewMenuRow(row);
  };
  const handleCloseReviewMenu = () => {
    setReviewAnchorEl(null);
    setReviewMenuRow(null);
  };
  const handleOpenReviewDialog = (action) => {
    setReviewTargetTask(reviewMenuRow);
    setReviewAction(action);
    setReviewDialogOpen(true);
    handleCloseReviewMenu();
  };
  const handleCloseReviewDialog = () => {
    if (reviewSubmitting) return;
    setReviewDialogOpen(false);
    setReviewAction(null);
    setReviewTargetTask(null);
    setReviewNotes("");
  };
  const getSelectedTaskId = (task) => {
    return task?.id || task?.task_id || task?.taskId || null;
  };
  const reviewT = (key) =>
    t(`taskReview.${key}`, {
      defaultValue: t(`punchesDetailsDrawer.taskReview.${key}`),
    });
  const submitReviewDecision = async () => {
    const selectedTaskId = getSelectedTaskId(reviewTargetTask);
    if (!selectedTaskId || !reviewAction) return;
    if (!authToken) {
      toast.error(reviewT("failedUpdate"));
      return;
    }

    try {
      setReviewSubmitting(true);
      setReviewLoadingTaskId(selectedTaskId);

      const response = await fetch(
        `${BASE_URL}/task-management/admin/tasks/${selectedTaskId}/validation/${reviewAction}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            task_id: selectedTaskId,
            review_notes: reviewNotes?.trim() || null,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok || data?.error) {
        toast.error(data?.message || reviewT("failedUpdate"));
        return;
      }

      toast.success(
        reviewAction === "approve"
          ? reviewT("successApprove")
          : reviewT("successReject")
      );

      handleCloseReviewDialog();
      await fetchTasks(page, sortOrder, effectiveFilters, searchTerm);
    } catch (error) {
      toast.error(reviewT("failedUpdate"));
    } finally {
      setReviewSubmitting(false);
      setReviewLoadingTaskId(null);
    }
  };
  const getReviewStatusLabel = (status) => {
    const normalized = (status || "pending").toLowerCase();
    return t(`reviewStatus.${normalized}`);
  };
  const fetchAllTasks = async () => {
    try {
      let url = `${BASE_URL}/task-management/admin/tasks?no_pagination=true&sort=created_at:${sortOrder}`;

      if (effectiveFilters.startDate) {
        url += `&from=${encodeURIComponent(effectiveFilters.startDate)}`;
      }
      if (effectiveFilters.endDate) {
        url += `&to=${encodeURIComponent(effectiveFilters.endDate)}`;
      }
      if (effectiveFilters.priority) url += `&priority=${effectiveFilters.priority}`;

      console.log("📡 Fetching ALL tasks:", url);

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });

      const json = await res.json();

      if (json.error) {
        console.error("❌ Error:", json.message);
        return [];
      }

      const allTasks = json.data?.tasks || [];

      return allTasks.map((task) => ({
        id: task.id,
        title: task.title,
        assigned_by_name: task.assigned_by_name || "-",
        priority: task.priority || "-",
        created_at: formatDateTime(task.created_at),
        end_at: formatDateTime(task.end_at),
        status: task.status || "-",
      }));

    } catch (err) {
      console.error("❌ Error fetching all tasks:", err);
      return [];
    }
  };


  const handleEdit = async () => {
    if (!selectedRow?.id) return;

    try {
      const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${selectedRow.id}`, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const data = await res.json();

      if (!data.error) {
        const task = {
          ...data.data.task,
          assignments: data.data.assignments || [],
        };
        console.log("✅ Full task fetched for edit:", task);
        setSelectedRow(task);
        setOpenEditTask(true);
      } else {
        toast.error(data.message || "Failed to fetch task details");
      }
    } catch (err) {
      console.error("❌ Error fetching task details:", err);
    }
  };

  const { logoBase64, } = useCompanyProfile(decryptedToken);
  if (isInitialLoad && loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
        }}
      >
        <CircularProgress size={40} />
      </Box>
    );
  }

  return (
    <>




      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 2,
          py: 2,
          mt: 3,
          border: "2px solid #091E4224",
        }}
      >
        {/* ✅ Header with Search & Add */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: isMobile ? "wrap" : "nowrap",
            pb: 2,
            px: 2,
            borderBottom: "2px solid #091E4224",
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1, display: "flex", alignItems: "center", gap: 1 }}>

            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 600,
                fontSize: "18px",
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("projectManagement.manageTasks")}
            </CustomText>
            {loading && !isInitialLoad && (
              <CircularProgress size={18} sx={{}} />
            )}
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <SearchInput
              placeholder={t("projectManagement.searchProjects")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <ExportDropdown
              onDownloadPDF={async () => {
                const allTasks = await fetchAllTasks();  // 🚀 fetch full data
                const blob = await pdf(<ExportTasksPDF data={allTasks} logo={logoBase64} />).toBlob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = `Tasks_Report ${new Date()
                  .toISOString()
                  .slice(0, 10)}.pdf`;
                link.click();
              }}
              onDownloadExcel={async () => {
                const allTasks = await fetchAllTasks();  // 🚀 fetch full data
                ExportTasksExcel(allTasks);
              }}
            />         <Button
              variant="contained"
              onClick={() => setOpenAddTask(true)}
              size="small"
              sx={{
                px: 2,
                backgroundColor: "#006EC2",
                height: 32,
                fontSize: 14,
                fontWeight: 400,
                fontFamily: "Poppins, sans-serif",
                borderRadius: "4px",
                textTransform: "none",
              }}
              startIcon={<AddIcon sx={{ fontSize: 18 }} />}
            >
              {t("projectManagement.create")}
            </Button>
            {/* <img
            src={tablefilter}
            width={33}
            height={33}
            style={{ cursor: "pointer" }}
                   onClick={() => setOpenFilterDrawer(true)} // ✅ open drawer

          /> */}
            {/* {isFilterApplied ? ( */}
            {isAnyFilterApplied ? (
              <Box
                sx={{
                  position: "relative",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 34,
                  height: 34,
                  borderRadius: 1,
                  bgcolor: "#1976d2", // blue when applied
                }}
              >
                {/* Filter Icon (white) */}
                <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

                {/* Cross Icon (to clear filters) */}
                <IconButton
                  size="small"
                  // onClick={() => {
                  //   // setFilters({ priority: "", startDate: "", endDate: "" }); // reset

                  //   setPage(1);
                  //   setIsFilterApplied(false);
                  // }}
                  onClick={() => {
                    setFilters({status:"", priority: "", startDate: "", endDate: "" });
                    setPage(1);

                    if (statusFilter) {
                      onClearStatus(); // ✅ clears card status filter
                    }
                    //  isAnyFilterApplied(false);

                  }}
                  sx={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    bgcolor: "white",
                    width: 18,
                    height: 18,
                    border: "1px solid #C4C4C4",
                    "&:hover": { bgcolor: "#f5f5f5" },
                  }}
                >
                  <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
                </IconButton>
              </Box>
            ) : (
              <IconButton
                onClick={() => setOpenFilterDrawer(true)}
                sx={{
                  border: "1px solid #C4C4C4",
                  borderRadius: 1,
                  width: 34,
                  height: 34,
                }}
              >
                <FilterAltIcon />
              </IconButton>
            )}
          </Box>
        </Box>
        <Box sx={{ px: 2, pt: 1 }}>
          <Tabs
            value={taskViewTab}
            onChange={(_, newValue) => {
              setTaskViewTab(newValue);
              setPage(1);
            }}
            sx={{
              minHeight: 38,
              "& .MuiTab-root": {
                minHeight: 38,
                textTransform: "none",
                fontSize: "14px",
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
              },
            }}
          >
            <Tab value="today" label={t("todays_task")} />
            <Tab value="all" label={t("all_tasks")} />
          </Tabs>
        </Box>

        {/* ✅ Table */}
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead
              sx={{
                borderTop: "2px solid #091E4224",
                borderBottom: "2px solid #091E4224",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <TableRow>
                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.id")}</TableCell>
                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.taskName")}</TableCell>
                {/* <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.assigningTeam")}</TableCell>
               */}
                <TableCell sx={HaederStyles}>{t("workerName")}</TableCell>
                <TableCell sx={HaederStyles}>{t("workerEmail")}</TableCell>
                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.priority")}</TableCell>


                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.createdAt")}

                  <IconButton size="small" onClick={toggleSort}>
                    {sortOrder === "desc" ? (
                      <ArrowDownward fontSize="small" sx={{ fontSize: "12px" }} />
                    ) : (
                      <ArrowUpward fontSize="small" sx={{ fontSize: "12px" }} />
                    )}
                  </IconButton>
                </TableCell>

                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.deadline")}</TableCell>
                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.status")}</TableCell>
                <TableCell sx={{ ...HaederStyles, textAlign: "center" }}>{t("reviewStatusLabel")}</TableCell>
                <TableCell sx={{ ...HaederStyles }}>{t("projectManagement.action")}</TableCell>
              </TableRow>
            </TableHead>





            <TableBody>
              {!loading && (
                filteredTasks.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10}>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          py: 5,
                        }}
                      >
                        <img
                          src={empty}
                          alt="No Data"
                          style={{ width: 200, marginBottom: 16 }}
                        />
                        <CustomText
                          sx={{
                            ...textStyles.h1,
                            fontWeight: 500,
                            fontSize: "16px",
                            color: "#003149",
                          }}
                        >
                          {t("empty.no_user")}
                        </CustomText>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  filteredTasks.map((row) => (
                    <TableRow
                      key={row.id}
                      hover
                      sx={{ cursor: "pointer" }}
                      onClick={() => onMapFilter(row.id)}
                    >
                      <TableCell sx={DataStyles}>{row.id}</TableCell>

                      <TableCell sx={DataStyles}>
                        <TruncatedCell text={row.title} />
                      </TableCell>

                      <TableCell sx={DataStyles}>
                        {row.assigned_workers?.[0]?.worker_name || "-"}
                      </TableCell>

                      <TableCell sx={DataStyles}>
                        {row.assigned_workers?.[0]?.worker_email || "-"}
                      </TableCell>

                      <TableCell>
                        <Box sx={{ pointerEvents: "none" }}>
                          <StatusDropdown currentStatus={row.priority} />
                        </Box>
                      </TableCell>

                      <TableCell sx={DataStyles}>
                        {formatDateTime(row.created_at)}
                      </TableCell>

                      <TableCell sx={DataStyles}>
                        {formatDateTime(row.end_at)}
                      </TableCell>

                      <TableCell>
                        <Box sx={{ pointerEvents: "none" }}>
                          <StatusDropdown currentStatus={row.status} />
                        </Box>
                      </TableCell>

                      <TableCell sx={{ ...DataStyles, textAlign: "center" }}>
                        {(() => {
                          const normalizedTaskStatus = String(row.status || "")
                            .trim()
                            .toLowerCase();
                          const isTaskPending = normalizedTaskStatus === "pending";
                          const isTaskAssigned = normalizedTaskStatus === "assigned";
                          const isTaskCancelled = normalizedTaskStatus === "cancelled";
                          const reviewStatus = (row.review_status || "pending").toLowerCase();
                          const isReviewPending = reviewStatus === "pending";

                          if (isTaskPending || isTaskAssigned || isTaskCancelled) {
                            return <Box sx={{ width: "100%", textAlign: "center" }}>--</Box>;
                          }

                          return (
                        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <Box
                          sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 0.3,
                            border: "1px solid #C4C4C4",
                            borderRadius: "16px",
                            px: 1.2,
                            py: 0.3,
                            fontFamily: "Poppins, sans-serif",
                            backgroundColor: "#F8FAFC",
                            cursor: isReviewPending ? "pointer" : "default",
                          }}
                          onClick={(e) => {
                            if (isReviewPending) {
                              handleOpenReviewMenu(e, row);
                            } else {
                              e.stopPropagation();
                            }
                          }}
                        >
                          {getReviewStatusLabel(row.review_status)}
                          {isReviewPending && (
                            <KeyboardArrowDownRoundedIcon sx={{ fontSize: 16 }} />
                          )}
                        </Box>
                        </Box>
                          );
                        })()}
                      </TableCell>

                      <TableCell>
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )
              )}
            </TableBody>

          </Table>
        </TableContainer>

        {/* ✅ Pagination */}
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", mt: 2 }}>
          <Pagination
            count={totalPages}       // ✅ from backend
            page={page}              // ✅ current page
            onChange={(_, v) => setPage(v)} // ✅ updates state, triggers fetch
            shape="rounded"
            color="primary"
            size="small"
          />
        </Box>
        <Menu
          anchorEl={reviewAnchorEl}
          open={Boolean(reviewAnchorEl)}
          onClose={handleCloseReviewMenu}
          onClick={(e) => e.stopPropagation()}
        >
          <MenuItem onClick={() => handleOpenReviewDialog("approve")} sx={{ fontSize: "12px" }}>
            {reviewT("approve")}
          </MenuItem>
          <MenuItem onClick={() => handleOpenReviewDialog("reject")} sx={{ fontSize: "12px" }}>
            {reviewT("reject")}
          </MenuItem>
        </Menu>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleView} sx={{ fontSize: "12px" }}>
            {t("common.view")}
          </MenuItem>
          <MenuItem
            // onClick={() => {
            //   setOpenEditTask(true);

            //   handleMenuClose();
            // }}
            // onClick={handleEdit} 
            onClick={() => {
              handleEdit();   // fetch & open drawer
              handleMenuClose();  // closes MUI <Menu>
            }}
            sx={{ fontSize: "12px" }}
          >
            {t("common.edit")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              console.log("🗑 Opening delete for id:", selectedRow?.id);
              setDeleteTaskId(selectedRow?.id);         // stash the id
              setOpenDeleteModal(true);
              handleMenuClose();                        // only closes menu
            }}
            sx={{ fontSize: "12px", }}
          >
            {t("common.delete")}

          </MenuItem>
          {/* Later you can add Edit/Delete here */}
        </Menu>

        <EditTask
          open={openEditTask}
          onClose={() => setOpenEditTask(false)}
          taskToEdit={selectedRow}
          onTaskUpdated={() => {
            fetchTasks(page, sortOrder, effectiveFilters, searchTerm); // ✅ refresh table
            window.dispatchEvent(new Event('tasks:updated')); // ✅ refresh calendar & map
          }}
        />

        <AddTask open={openAddTask} onClose={() => setOpenAddTask(false)}
          onTaskCreated={() => {
            fetchTasks(page, sortOrder, effectiveFilters, searchTerm); // ✅ refresh table
            window.dispatchEvent(new Event('tasks:updated')); // ✅ refresh calendar & map
          }}
        />
        <DeleteTaskModal
          open={openDeleteModal}
          onClose={() => {
            setOpenDeleteModal(false);
            setDeleteTaskId(null);
          }}
          taskId={deleteTaskId}
          onTaskDeleted={() => {
            fetchTasks(page, sortOrder, effectiveFilters, searchTerm); // ✅ refresh table
            window.dispatchEvent(new Event('tasks:updated')); // ✅ refresh calendar & map
          }}
        />
        <FilterDrawer
          open={openFilterDrawer}
          onClose={() => setOpenFilterDrawer(false)}
          filters={filters}
          setFilters={setFilters}
          onApplyFilters={(newFilters) => {
            setFilters(newFilters);
            setIsFilterApplied(
              !!newFilters.priority || !!newFilters.startDate || !!newFilters.endDate
            );
          }}
        />
        <Dialog
          open={reviewDialogOpen}
          onClose={handleCloseReviewDialog}
          fullWidth
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: 3,
              p: 1,
            },
          }}
        >
          <DialogContent sx={{ pt: 3 }}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 1.5 }}>
              <img src={logoutmodel} alt="review" style={{ width: 64, height: 64 }} />
            </Box>
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 600,
                fontSize: "18px",
                color: "#003149",
                textAlign: "center",
              }}
            >
              {reviewAction === "approve"
                ? reviewT("approveTitle")
                : reviewT("rejectTitle")}
            </CustomText>
            <Box sx={{ mt: 1, mb: 2, color: "#44546F", fontSize: 14, textAlign: "center" }}>
              {reviewAction === "approve"
                ? reviewT("approveConfirm")
                : reviewT("rejectConfirm")}
            </Box>
            <CustomText
              sx={{
                fontSize: "16px",
                fontWeight: 500,
                color: "#172B4D",
                mb: 0.8,
                textAlign: "left",
                fontFamily: "Poppins, sans-serif",
              }}
            >
              {reviewT("reviewNote")}
            </CustomText>
            {/* <TextField
              placeholder={reviewT("reviewNotePlaceholder")}
              multiline
              minRows={3}
              fullWidth
              value={reviewNotes}
              onChange={(e) => setReviewNotes(e.target.value)}
            /> */}
            <textarea
            placeholder={reviewT("reviewNotePlaceholder")}
            value={reviewNotes}
            onChange={(e) => setReviewNotes(e.target.value)}
            className="project_input"
            style={{height:"120px",width:"100%",paddingTop:"10px"}}>

            </textarea>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2, justifyContent: "center", gap: 1.2 }}>
            <CustomButton
              onClick={handleCloseReviewDialog}
              disabled={reviewSubmitting}
              size="small"
              label={t("common.cancel")}
              sx={{
                color: "#172B4D",
                backgroundColor: "white",
                "&:hover": {
                  backgroundColor: "white",
                  color: "#172B4D",
                },
              }}
            />
            <CustomButton
              onClick={submitReviewDecision}
              disabled={reviewSubmitting}
              size="small"
              sx={{ minWidth: 120 }}
              label={
                reviewSubmitting ? (
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                ) : reviewAction === "approve" ? (
                  reviewT("approve")
                ) : (
                  reviewT("reject")
                )
              }
            />
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default TasksTable;


